import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import ToDoTab from './ToDoTab';

export default function Todo() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem('token')) navigate('/login');
  }, [navigate]);

  return (
    <div className="app-page">
      <Navbar back={{ to: '/dashboard', label: 'Back' }} />
      <main className="app-page-main" data-testid="todo-page">
        <div className="app-page-header">
          <h1 className="app-page-title" data-testid="todo-page-title">To Do</h1>
        </div>
        <ToDoTab />
      </main>
    </div>
  );
}
